<div id="content" class="allcp-form" ng-controller="TaskController" ng-init="projects()">
<div ng-include="'modules/company/menus/task_menu.html'"></div>
<div class="row p50">
    <div class="panel-heading m10 p30 text-center project-list" style="background: #056496;">
        <a href="#" data-toggle="modal" data-target="#newProject" ng-click="newProject()" style="color:#fff">
            <i class="fa fa-plus fs24"></i>
        </a>
    </div>
    <div 
        class="panel-heading m10 p30 text-center project-list"
        style="overflow: inherit;"
        ng-style="{'background': project.color}" 
        ng-repeat="project in data.projects | filter:{ name: project_name }">
        <a href="proje/{{ project.id }}" class="p50">
            <strong style="color:#fff" class="hint--medium hint--top" aria-label="{{ project.name }}">{{ project.name | cut:true:20:' ...' }}</strong>
        </a>

        <a href="#" 
            ng-click="deleteProject(project.id,'set')" 
            class="edit-project mr40">
            <i class="fa fa-trash fs14"></i>
        </a>
        <a href="#" ng-click="editProject(project)" class="edit-project">
            <i class="fa fa-pencil fs14"></i>
        </a>
    </div>
</div>
 
<div class="modal right" id="newProject" tabindex="-1" role="dialog" aria-labelledby="newProjectLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h5 class="modal-title"> 
                <strong ng-if="project.id"> Proje Düzenle</strong>
                <strong ng-if="!project.id"> Yeni Proje Ekle</strong>
            </h5>
        </div>
        <form ng-submit="saveProject()" class="form-horizontal allcp-form">
        <div class="modal-body">
            <div class="form-group">
                <label class="col-md-3 control-label">Proje Adı * : </label>
                <div class="col-md-9">
                    <label for="name21" class="field prepend-icon">
                        <input type="text" ng-model="project.name" class="gui-input br-light light" placeholder="Proje Adı" required>
                        <label for="name21" class="field-icon">
                            <i class="fa fa-list-alt"></i>
                        </label>
                    </label>
                </div>
            </div>

            <div class="form-group" ng-init="project.color = colorList[0]">
                <label class="col-md-3 control-label">Renk * : </label>
                <div class="col-md-9">
                    <ul class="color-palette" >
                        <li 
                            ng-repeat="color in colorList"
                            ng-style="{'background-color': color }"
                            class="color-selected" 
                            ng-click="project.color = color" 
                            ng-class="project.color == color ? 'selected' : ''">
                        </li>
                    </ul>
                </div>
            </div>

        </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Vazgeç</button>
                <button type="submit" class="btn btn-primary" ng-if="!project.id">Ekle</button>
                <button type="submit" class="btn btn-warning" ng-if="project.id">Güncelle</button>
            </div>
        </form>
        
        </div>
    </div>
</div>

<div class="modal fade" id="deleteProject" tabindex="-1" role="dialog" aria-labelledby="deleteProjectLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h5 class="modal-title"> <strong> Dikkat!</strong></h5>
        </div>
        <div class="modal-body">
            <strong class="text-danger">
                <i class="fa fa-exclamation-triangle"></i> Yapacağınız silme işlemi geri alınamaz bir işlemdir.
            </strong>
            <p><strong>Silmek istediğinizden emin misiniz ? </strong> </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-danger" ng-click="deleteProject('','delete')" data-dismiss="modal">Sil</button>
        </div>
        </div>
    </div>
</div>

</div>